'use client';

import Card from '@/components/card/Card';
import { DirectusFiles, FfbbsiteBlockButton, FfbbsiteSelfPromotion, FfbbsitePages } from '@/lib/directus';
import getDirectusImageUrl from '@/lib/utils/image';
import { AppConfig } from '@/utils/AppConfig';
import { useEffect, useState } from 'react';
import { sendGTMEvent } from '@next/third-parties/google';

interface Props {
  promotions: Array<FfbbsiteSelfPromotion>;
}

export default function PromotionImage({ promotions }: Props) {
  const [selectedPromotion, setSelectedPromotion] = useState<FfbbsiteSelfPromotion | null>(null);

  useEffect(() => {
    if (!promotions.length) {
      return;
    }
    const randomIndex = Math.floor(Math.random() * promotions.length);
    const promotion = promotions[randomIndex];
    setSelectedPromotion(promotion);
    if (promotion.followGa) {
      sendGTMEvent({event: 'promotion_view', value: promotion.title_analytics || promotion.id});
    }
  }, [promotions]);

  const promotionClick = () => {
    if (selectedPromotion?.followGa) {
      sendGTMEvent({event: 'promotion_clicked', value: selectedPromotion.title_analytics || selectedPromotion.id});
    }
  }
  const bannerFull = selectedPromotion?.banner_square as DirectusFiles;
  const directusImageId = bannerFull?.id;
  const blockButton = selectedPromotion?.target as FfbbsiteBlockButton;
  const title = '';

  let url = blockButton?.external_url;
  const external = blockButton?.external_url ? true : false;
  if (!url && blockButton?.type === 'page' && blockButton?.page) {
    url = '/'+(blockButton?.page as FfbbsitePages)?.permalink;
  }

  if (!promotions.length) {
    return <></>;
  }

  return (
    <div className="h-[270px]" onClick={promotionClick} onKeyDown={promotionClick} role="button" tabIndex={0}>
      <Card
        type="image"
        {...{
          title: title || '',
          description: '',
          intro: '',
          image: directusImageId ? getDirectusImageUrl(directusImageId, true, 750, 0, undefined, 'avif') : '',
          callToActionUrl: {
            url: url || '',
            slug: '',
            external,
          },
          imageSizes: '(min-width: 66em) 20vw, (min-width: 44em) 50vw, 100vw',
        }}
      />
    </div>
  );
}
